import Component from '@glimmer/component';
import Session from 'mewe/shared/session';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import FunctionalUtils from 'mewe/shared/functional-utils';

export default class NewApplicationRequest extends Component {

  @tracked isLoading = false;

  get applicationName() {
    return this.args.notification?.application?.name;
  }

  get appId() {
    return this.args.notification?.application?.id;
  }

  @action
  async approveRequest(appId) {
    this.isLoading = true;
    try {
      await fetch(`/api/v2/user/applications/pending/${appId}`, {
        method: 'POST',
        headers: {
          'X-CSRF-Token': Session.getCsrfToken(),
        },
      });
      this.args.refreshModel?.();
    } catch (error) {
      console.error('Failed to approve app request:', error);
      FunctionalUtils.showDefaultErrorMessage();
    } finally {
      this.isLoading = false;
    }
  }

  @action
  async rejectRequest(appId) {
    this.isLoading = true;
    try {
      await fetch(`/api/v2/user/applications/pending/${appId}`, {
        method: 'DELETE',
        headers: {
          'X-CSRF-Token': Session.getCsrfToken(),
        },
      });
      this.args.refreshModel?.();
    } catch (error) {
      console.error('Failed to reject app request:', error);
      FunctionalUtils.showDefaultErrorMessage();
    } finally {
      this.isLoading = false;
    }
  }

}
